import { VatDeclarationStatus } from '../../../../../enums/vatDeclarationStatus'

const vatDeclarationStatusToStatusKey = {
  [VatDeclarationStatus.Draft]: 'vat_declarations.status_card.title.to_submit',
  [VatDeclarationStatus.ReadyToSubmit]: 'vat_declarations.status_card.title.to_submit',
  [VatDeclarationStatus.Pending]: 'vat_declarations.status_card.title.to_submit',
  [VatDeclarationStatus.ReadyToPay]: 'vat_declarations.status_card.title.payment_due_date',
  [VatDeclarationStatus.Paid]: 'vat_declarations.status_card.title.payment_date',
  [VatDeclarationStatus.SubmissionFailed]: 'vat_declarations.status_card.title.to_submit',
  [VatDeclarationStatus.OverduePayment]: 'vat_declarations.status_card.title.overdue_payment',
  [VatDeclarationStatus.OverdueSubmission]: 'vat_declarations.status_card.title.overdue_submission',
}

export const getStatusKey = (status: VatDeclarationStatus, isSettled?: boolean): string => {
  return vatDeclarationStatusToStatusKey[status]
}
